module.exports = __webpack_public_path__ + "static/img/error.0d5da4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/layout/error-page/error.png
// module id = BL2u
// module chunks = 7